export default "__VITE_ASSET__74c47393__"